<template>
  <div class="second-Bar">
    <div class="bar-top">
      <router-link
        :to="$i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })"
        v-for="item in list.slice(0, 3)"
        :key="item.id"
        class="card"
      >
        <div class="card-block">
          <span class="category">{{ item.sub_category.name }}</span>
          <div class="image-block">
            <ImageContainer
              :src="item.image.medium"
              :alt="item.title"
              :thumb="item.image.thumbnail"
              class="image"
            />
          </div>
          <div class="about">
            <span class="category-alter">{{ item.sub_category.name }}</span>
            <h1 class="text">
              {{ item.title }}
            </h1>
            <h2 class="time">
              {{ handleDate(item.pub_date) }}, {{ handleTime(item.pub_date) }}
            </h2>
          </div>
          <svg
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="decor-line-sm"
          >
            <line
              x1="100%"
              y1="0.5"
              y2="0.5"
              stroke="#777F9C"
              stroke-dasharray="15 15"
            />
          </svg>
        </div>
      </router-link>
    </div>
    <div class="bar-bottom">
      <router-link
        :to="$i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })"
        v-for="item in list.slice(3, 5)"
        :key="item.id"
        class="card"
      >
        <span class="category-alter">{{ item.sub_category.name }}</span>
        <div class="image-block">
          <ImageContainer
            :src="item.image.medium"
            :alt="item.title"
            :thumb="item.image.thumbnail"
            class="image"
          />
        </div>
        <div class="about">
          <span class="category">{{ item.sub_category.name }}</span>
          <h1 class="text">
            {{ item.title }}
          </h1>
          <h2 class="time">
            {{ handleDate(item.pub_date) }}, {{ handleTime(item.pub_date) }}
          </h2>
        </div>
        <svg
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="decor-line-sm"
        >
          <line
            x1="100%"
            y1="0.5"
            y2="0.5"
            stroke="#777F9C"
            stroke-dasharray="15 15"
          />
        </svg>
      </router-link>
    </div>
  </div>
</template>
<script>
import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";
export default {
  name: "SecondBar",
  components: {
    ImageContainer,
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
  setup() {
    return {
      ...useFormatter(),
    };
  },
};
</script>
<style lang="scss" scoped>
.second-Bar {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: #fff;
  .bar-top {
    text-align: center;
    display: flex;
    justify-content: space-between;
    width: 80%;
    margin: 0 auto;
    position: relative;
    .card {
      position: relative;
      min-width: calc(100% / 3);
      color: #fff;
      // max-width: 454px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .card-block {
        position: relative;
        width: 80%;
        background: #4b4d61;
        border-radius: 250px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .category {
          position: relative;
          font-family: Open Sans;
          font-style: normal;
          font-weight: 600;
          font-size: 2em;
          line-height: 1.1;
          opacity: 0.7;
          text-transform: uppercase;
          margin: 2% 0;
        }
        .image-block {
          position: relative;
          width: 110%;
          // max-width: 454px;
          .image {
            // max-width: 454px;
            position: relative;
            display: flex;
            align-items: center;
            width: 100%;
            aspect-ratio: 454/283;
            border-radius: 250px;
          }
        }
        .about {
          position: relative;
          width: 100%;
          font-size: 2.2em;
          font-style: normal;
          line-height: 1.5;
          margin: 0.6rem 0;
          .category-alter {
            display: none;
            position: relative;
            font-family: Open Sans;
            font-style: normal;
            font-weight: 600;
            font-size: 0.8em;
            line-height: 1.3;
            opacity: 0.7;
            text-transform: uppercase;
          }
          .text {
            font-family: Roboto;
            position: relative;
            font-weight: 600;
            --snup: 3;
            display: -webkit-box;
            -webkit-line-clamp: var(--snup);
            -webkit-box-orient: vertical;
            overflow: hidden;
            margin: 0 10%;
          }
          .time {
            font-family: "Open Sans", sans-serif;
            position: relative;
            font-weight: normal;
            opacity: 0.7;
            margin: 0.5rem 20%;
          }
        }
        .decor-line-sm {
          display: none;
        }
      }
    }
  }
  .bar-bottom {
    position: relative;
    background: #4b4d61;
    display: flex;
    justify-content: space-between;
    border-radius: 260px 260px 0px 0px;
    margin: 2% auto;
    width: 90%;
    .card {
      width: 40%;
      position: relative;
      margin: 2% 0;
      .category-alter {
        position: relative;
        font-family: Open Sans;
        font-weight: 600;
        font-size: 0.9em;
        opacity: 0.7;
        text-transform: uppercase;
        font-style: normal;
        line-height: 1;
        display: none;
        text-align: center;
      }
      .image-block {
        position: relative;
        width: 100%;
        // max-width: 689px;
        aspect-ratio: 689/420;
        .image {
          // max-width: 689px;
          position: relative;
          display: flex;
          align-items: center;
          width: 100%;
        }
      }
      .about {
        bottom: 0;
        position: absolute;
        background: rgba(75, 77, 97, 0.65);
        width: 60%;
        padding: 3% 5%;
        font-size: 2.2em;
        font-style: normal;
        line-height: 1.4;
        .category {
          position: relative;
          font-family: Open Sans;
          font-weight: 600;
          font-size: 0.9em;
          opacity: 0.7;
          text-transform: uppercase;
          // margin: 5% 0;
        }
        .text {
          font-family: Roboto;
          position: relative;
          font-weight: 600;
          --snup: 2;
          display: -webkit-box;
          -webkit-line-clamp: var(--snup);
          -webkit-box-orient: vertical;
          overflow: hidden;
          margin: 2% 0;
          font-size: 1em;
        }
        .time {
          font-family: "Open Sans", sans-serif;

          position: relative;
          font-weight: normal;
          opacity: 0.7;
          font-size: 1em;
          // margin: 0.5rem 20%;
        }
      }
      .decor-line-sm {
        display: none;
      }
      &:nth-child(1) {
        margin-left: 6%;
        .image-block {
          .image {
            border-radius: 210px 0 0 0;
          }
        }
        .about {
          text-align: end;
          right: 0;
          border-radius: 109px 0 0 0;
        }
      }
      &:nth-child(2) {
        margin-right: 6%;
        .image-block {
          .image {
            border-radius: 0 210px 0 0;
          }
        }
        .about {
          text-align: start;
          left: 0;
          border-radius: 0 109px 0 0;
        }
      }
    }
  }
}
@media screen and (max-width: 2900px) {
  .second-Bar {
    .bar-top {
      .card {
        .card-block {
          border-radius: 8.84em;
          .category {
            font-size: 1.2em;
          }
          .image-block {
            width: 115%;
            .image {
              border-radius: 141.5px;
            }
          }
          .about {
            font-size: 1.3em;
          }
          .decor-line-sm {
            display: none;
          }
        }
      }
    }
    .bar-bottom {
      .card {
        .image-block {
          aspect-ratio: 689/420;
        }
        .about {
          font-size: 1.2em;
        }
        .decor-line-sm {
          display: none;
        }
      }
    }
  }
}
@media screen and (max-width: 1920px) {
  .second-Bar {
    .bar-top {
      .card {
        max-width: 454px;
        .card-block {
          border-radius: 8.84em;
          .category {
            font-size: 1.1em;
          }
          .image-block {
            width: 115%;
            max-width: 454px;
            .image {
              // max-width: 454px;
              border-radius: 141.5px;
            }
          }
          .about {
            font-size: 1.1em;
          }
          .decor-line-sm {
            display: none;
          }
        }
      }
    }
    .bar-bottom {
      .card {
        .image-block {
          max-width: 689px;
          aspect-ratio: 689/420;
          .image {
            // max-width: 689px;
          }
        }
        .about {
          font-size: 1em;
        }
        .decor-line-sm {
          display: none;
        }
      }
    }
  }
}

@media screen and (max-width: 978px) {
  .second-Bar {
    // background-color: #60657d;
    padding-top: 1rem;
    .bar-top {
      width: 100%;
      .card {
        .card-block {
          border-radius: 74px;
          .category {
            position: absolute;
            top: -8%;
            font-size: 0.9em;
          }
          .image-block {
            aspect-ratio: 236/162;
            border-radius: 150px;
            max-width: 236px;
          }
          .about {
            margin: 0.4rem 0;
            .text {
              font-size: 0.9em;
              margin: 0 5%;
            }
            .time {
              font-size: 0.9em;
              margin: 0.3rem 15%;
            }
          }
          .decor-line-sm {
            display: none;
          }
        }
      }
    }
    .bar-bottom {
      // border-radius: 0px 217px 217px 0px;
      border-radius: 0 9.3em 9.3em 0;
      margin: 2% 0;
      width: 98%;
      justify-content: space-around;
      .card {
        max-width: 326px;
        width: 50%;
        margin: 1% 1% !important;
        .category-alter {
          display: block;
          margin-bottom: 2%;
        }
        .image-block {
          max-width: 326px;
          aspect-ratio: 326/224;
          // border-radius: 150px;
          .image {
            border-radius: 150px !important;
          }
        }
        .about {
          position: relative;
          width: 80%;
          background: none;
          text-align: center !important;
          padding: 1% 0;
          margin: 0 auto;
          line-height: 1.2;
          .category {
            display: none;
          }
          .text {
            --snup: 3;
          }
        }
        .decor-line-sm {
          display: none;
        }
        &:nth-child(2) {
          margin-right: 2% !important;
        }
      }
    }
  }
}
@media screen and (max-width: 775px) {
  .second-Bar {
    .bar-bottom {
      .card {
        &:nth-child(2) {
          margin-right: 5% !important;
        }
        .about {
          width: 75%;
        }
      }
    }
  }
}
@media screen and (max-width: 475px) {
  .second-Bar {
    .bar-top {
      flex-direction: column;
      .card {
        .card-block {
          border-radius: 0;
          width: 58%;
          .category {
            display: none;
          }
          .image-block {
            max-width: none;
            margin-top: 1rem;
            .image {
              border-radius: 100.5px;
              aspect-ratio: 307/207;
            }
          }
          .about {
            margin-top: 0.5rem;
            .category-alter {
              display: block;
            }
          }
          .decor-line-sm {
            display: block;
            position: relative;
            width: 100%;
            height: 1px;
          }
        }
        &:nth-child(1) {
          .card-block {
            border-radius: 50% 50% 0 0;
            .image-block {
              margin-top: 0;
            }
          }
        }
      }
    }
    .bar-bottom {
      border-radius: 0;
      width: 58%;
      flex-direction: column;
      margin: 0 auto;
      background: none;
      .card {
        width: 100%;
        background: #4b4d61;
        margin: 0 !important;
        .category-alter {
          display: none;
        }
        .image-block {
          position: relative;
          max-width: none;
          margin-top: 1rem;
          width: 115%;
          left: 50%;
          transform: translateX(-50%);
          .image {
            border-radius: 100.5px;
            aspect-ratio: 307/207;
          }
        }
        .about {
          margin-top: 0.5rem;
          width: 90%;
          .category {
            display: block;
            margin: 2% 0;
          }
          .time {
            font-size: 0.95;
            margin: 0.5rem 0;
          }
        }
        .decor-line-sm {
          display: block;
          width: 100%;
          height: 1px;
        }
        &:nth-child(2) {
          background: none;
          background-image: linear-gradient(
            to bottom,
            #4b4d61 50%,
            rgba(255, 255, 255, 0) 50%,
            rgba(255, 255, 255, 0) 100%,
            rgb(4, 120, 21) 100%
          );
          .decor-line-sm {
            display: none;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 375px) {
  .second-Bar {
    .bar-top {
      .card {
        .card-block {
          .image-block {
            width: 141%;
          }
        }
      }
    }
    .bar-bottom {
      .card {
        .image-block {
          width: 141%;
        }
      }
    }
  }
}
</style>
